var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostNatal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_961_65417)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_961_65417",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.53674e-07H16V16H0V9.53674e-07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_961_65417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.23438 8.87109C4.23438 8.27691 4.71606 7.79522 5.31028 7.79522C5.90447 7.79522 6.38616 8.27691 6.38616 8.87109",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61719 8.87109C9.61719 8.27691 10.0989 7.79522 10.6931 7.79522C11.2873 7.79522 11.769 8.27691 11.769 8.87109",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14844 11.022C6.52272 11.6563 7.21272 12.082 8.00253 12.082C8.79234 12.082 9.48234 11.6563 9.85663 11.022",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5312 8.68125C15.5312 9.56188 14.8259 10.2778 13.9491 10.2944C13.2403 12.9153 10.8453 14.8438 8 14.8438C5.15469 14.8438 2.75969 12.9153 2.05094 10.2944C1.17406 10.2778 0.46875 9.56188 0.46875 8.68125C0.46875 8.23563 0.649375 7.83219 0.94125 7.54C1.22656 7.255 1.61781 7.07625 2.05094 7.06813C2.75969 4.44719 5.15469 2.51875 8 2.51875C10.8453 2.51875 13.2403 4.44719 13.9491 7.06813C14.3822 7.07625 14.7734 7.255 15.0587 7.54C15.3506 7.83219 15.5312 8.23563 15.5312 8.68125Z",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.998 4.52591C5.998 5.63344 6.89581 6.53125 8.00334 6.53125C9.11088 6.53125 10.0087 5.63344 10.0087 4.52591C10.0087 3.41838 9.11088 2.52056 8.00334 2.52056H7.68906C6.67425 2.52056 5.85156 1.69787 5.85156 0.683031",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99888 2.51953H5.53281C4.51797 2.51953 3.69531 1.69684 3.69531 0.682031",
    stroke: "#26252C",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_961_65417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostNatal);
export default __webpack_public_path__ + "static/media/post-natal.d6d2ac6d535712d10acec5f9de32c624.svg";
export { ForwardRef as ReactComponent };